<!--标题 -->
<template>
<div class="info-block">
  <router-link :to="'/hyzx/details/'+info.id" class="info-block-a"  target="_blank">
    {{info.title.length>titleLength?(info.title.substring(0,titleLength)+'...'):info.title}}
  </router-link>
</div>
</template>
<script>
export default {
  name: 'TitleInfoBlock01',
  props: {
    info: {
      type: Object,
      default: {}
    },
    titleLength:{
      type:Number,
      default:10
    }
  },
  data() {
    return {

    }
  },
  created:function(){

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info-block .info-block-a{
  display: block;
  position:relative;
  box-sizing:content-box;
  height:30px;
  line-height:30px;
  font-size:12px;
  color:#000;
  padding:0px 5px 0px 5px;
  margin:5px 0px 5px 0px;
  //background-color:green;
  border:0px solid #fff;
  background-size: 200px auto;
  background-repeat: no-repeat;
  background-position: 0px 0px;
  //box-shadow: #bbb 0px 0px 10px;
}

.info-block .info-block-a:hover{
  //border:1px solid #eee;
  //box-shadow:0px 0px 1px 1px orange;
  color:var(--color6)
}

.div-1{
  position:relative;
  height:30px;
  width:100%;
  padding:0px 0px 0px 0px;
  background:var(--color6);
  color:#fff;
}

</style>



// WEBPACK FOOTER //
// src/components/block/TitleInfoBlock01.vue